import { SettingsIcon, UsersIcon } from "lucide-react";

import {
  AccountSettingsAdminTable,
  AccountSettingsCompanyUsersTable,
  SettingsInviteUserDialog,
  TopbarContainer,
  TopbarTitle,
  UpdateUserForm,
} from "@/components";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

import { useCurrentCompanyId } from "@/hooks";
import { useGetCompanyUsersForSettings } from "@/hooks/queries";
import { storage } from "@/lib/storage";

const admins = [
  {
    name: "Simba Jonga",
    email: "simba@laborup.com",
  },
  {
    name: "Corbin Hooker",
    email: "corbin@laborup.com",
  },
];

export const SettingsPage = () => {
  const currentCompanyId = useCurrentCompanyId();
  const { data: companyUsers, status } = useGetCompanyUsersForSettings();

  // TODO: This is a common pattern so we should create a reusable piece of logic.
  const user = storage.getUser();
  if (!user) {
    throw new Error("User not found in local storage");
  }

  // TODO: This is a common pattern so we should create a reusable piece of logic.
  const currentCompany = user.companies.find(
    (company) => company.id === currentCompanyId,
  );
  if (!currentCompany) {
    throw new Error("Current company not found in user's companies");
  }

  if (status === "pending") {
    // TODO: Loading state.
    return null;
  } else if (status === "error") {
    // TODO: Error state.
    return null;
  }

  return (
    <>
      <TopbarContainer>
        <TopbarTitle>Account settings</TopbarTitle>
      </TopbarContainer>
      <div className="p-6">
        <Tabs
          // This is important to prevent the tabs from being controlled by keyboard shortcuts.
          activationMode="manual"
          defaultValue="users"
        >
          <TabsList>
            <TabsTrigger className="w-[145px]" value="users">
              User Permissions
            </TabsTrigger>
            <TabsTrigger className="w-[160px]" value="personal">
              Personal Information
            </TabsTrigger>
          </TabsList>
          <TabsContent className="mt-6" value="users">
            <div className="flex flex-col gap-6">
              <div className="flex flex-col gap-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-1">
                    <UsersIcon className="h-5 w-5 text-slate-700" />
                    <p className="font-medium text-slate-700">
                      {companyUsers.length} user
                      {companyUsers.length === 1 ? "" : "s"}
                    </p>
                  </div>
                  <SettingsInviteUserDialog
                    company={currentCompany}
                    currentUserId={user.id}
                  />
                </div>
                <AccountSettingsCompanyUsersTable
                  companyUsers={companyUsers}
                  currentUserEmail={user.email}
                  currentUserId={user.id}
                />
              </div>
              <div className="flex flex-col gap-4">
                <div className="flex items-center gap-1">
                  <SettingsIcon className="h-5 w-5 text-slate-700" />
                  <p className="font-medium text-slate-700">
                    {admins.length} admins
                  </p>
                </div>
                <AccountSettingsAdminTable admins={admins} />
              </div>
            </div>
          </TabsContent>
          <TabsContent className="mt-6" value="personal">
            <UpdateUserForm />
          </TabsContent>
        </Tabs>
      </div>
    </>
  );
};
